"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Column", {
  enumerable: true,
  get: function get() {
    return _Column.Column;
  }
});
Object.defineProperty(exports, "ColumnRenderer", {
  enumerable: true,
  get: function get() {
    return _ColumnRenderer["default"];
  }
});
Object.defineProperty(exports, "RowRenderer", {
  enumerable: true,
  get: function get() {
    return _RowRenderer["default"];
  }
});
Object.defineProperty(exports, "TableDesktop", {
  enumerable: true,
  get: function get() {
    return _TableDesktop["default"];
  }
});
Object.defineProperty(exports, "getFlexStyleForColumn", {
  enumerable: true,
  get: function get() {
    return _ColumnRenderer.getFlexStyleForColumn;
  }
});

var _Column = require("./table/Column");

var _ColumnRenderer = _interopRequireWildcard(require("./table/ColumnRenderer"));

var _RowRenderer = _interopRequireDefault(require("./table/RowRenderer"));

var _TableDesktop = _interopRequireDefault(require("./table/TableDesktop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }